import type { ReactElement } from 'react';
import { Badge } from '@/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

interface TruncatedBadgeProps {
  children: string;
  variant?: 'default' | 'secondary' | 'destructive' | 'outline';
  maxWidth?: string;
  className?: string;
  rightContent?: React.ReactNode;
}

export function TruncatedBadge({
  children,
  variant = 'secondary',
  maxWidth = '300px',
  className,
  rightContent,
}: TruncatedBadgeProps): ReactElement {
  const textContent = children;

  const textSpan = (
    <span className="truncate block min-w-0 flex-1">{textContent}</span>
  );

  const badgeContent = (
    <Badge
      variant={variant}
      className={cn(
        'text-xs inline-flex items-center gap-1 max-w-full',
        className
      )}
      style={{ maxWidth: `min(${maxWidth}, 100%)` }}
    >
      {textContent.trim().length > 0 ? (
        <Tooltip>
          <TooltipTrigger asChild>{textSpan}</TooltipTrigger>
          <TooltipContent>
            <p className="max-w-xs break-words whitespace-pre-wrap">
              {textContent}
            </p>
          </TooltipContent>
        </Tooltip>
      ) : (
        textSpan
      )}
      {rightContent}
    </Badge>
  );

  return badgeContent;
}
